import ResponsiveImage from '@/components/Image/ResponsiveImage';
import type { FrontifyImageContent } from '@/contentful/contentful-exports';

import useStyles from './SelectedImage.styles';

interface SelectedImageProps {
  image: string | FrontifyImageContent | undefined;
  zoomImageOnHover?: boolean;
}

export const SelectedImage: React.FC<SelectedImageProps> = ({
  image,
  zoomImageOnHover = true,
}) => {
  const { classes, cx } = useStyles();

  if (!image || typeof image === 'string') {
    return (
      <div className={classes.selectedImageContainer}>
        {/** biome-ignore lint/performance/noImgElement: Automated migration to Biome */}
        <img
          data-testid={'plain-image'}
          src={image}
          className={cx(
            classes.selectedImage,
            zoomImageOnHover && classes.hoverSelectedImage
          )}
          // biome-ignore lint/a11y/noRedundantAlt: Automated migration to Biome
          alt='Selected product image'
        />
      </div>
    );
  }

  return (
    <div className={classes.selectedImageContainer}>
      <ResponsiveImage
        src={image}
        alt='selected product image'
        className={cx(
          classes.selectedImage,
          zoomImageOnHover && classes.hoverSelectedImage
        )}
        sizes={{ xs: 650, sm: 1000, md: 650, lg: 650 }}
        data-testid='responsive-image'
      />
    </div>
  );
};
